import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-664f7050"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notification" }
const _hoisted_2 = { class: "notification-content" }
const _hoisted_3 = { class: "mytitle" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line-separate" }, null, -1))
const _hoisted_5 = { class: "notif-date" }
const _hoisted_6 = { class: "notif-msg" }
const _hoisted_7 = { class: "notif-thanks" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseWrapper = _resolveComponent("BaseWrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BaseWrapper, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t("notifTitle.value")), 1),
          _hoisted_4,
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("notifDate.value")), 1),
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("notifMsg.value")), 1),
          _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("notifThanks.value")), 1)
        ])
      ]),
      _: 1
    })
  ]))
}